import { useTranslation } from "react-i18next";
import { Icon, Label, Popup } from "semantic-ui-react";

import "modules/AppointmentDetails/components/CustomerActions/components/ServiceTrackerRating/ServiceTrackerRating.scss";

import type { CustomerCommunication } from "models";

type ServiceTrackerRatingProps = {
  customerCommunication?: CustomerCommunication;
};

type RatingItemProps = {
  question: string;
  rating: number;
};

const RatingItem = ({ question, rating }: RatingItemProps) => (
  <Label basic className="rating-item">
    <span>{question}</span>
    <Icon className="star" />
    <span>{rating}/5</span>
  </Label>
);

export const ServiceTrackerRating = ({ customerCommunication }: ServiceTrackerRatingProps) => {
  const { t } = useTranslation();

  const {
    star_rating_experience,
    star_rating_service,
    star_rating_speed,
    star_rating_feedback,
    star_rating_experience_message,
    star_rating_service_message,
    star_rating_speed_message
  } = customerCommunication || {};
  if (!star_rating_experience && !star_rating_service && !star_rating_speed) return null;

  return (
    <div className="ServiceTrackerRating">
      <div className="icon-container">
        <Icon className="circle star" />
      </div>

      <div className="rating-items">
        {star_rating_experience && (
          <RatingItem question={star_rating_experience_message || t("v8_how_easy_was_experience", "How easy was the experience?")} rating={star_rating_experience} />
        )}
        {star_rating_service && (
          <RatingItem question={star_rating_service_message || t("v8_rate_customer_service", "How do you rate our customer service?")} rating={star_rating_service} />
        )}
        {star_rating_speed && (
          <RatingItem question={star_rating_speed_message || t("v8_rate_speed_of_process", "How do you rate the speed of the process?")} rating={star_rating_speed} />
        )}
      </div>

      {star_rating_feedback && <Popup content={star_rating_feedback} trigger={<p className="rating-feedback">{star_rating_feedback}</p>} />}
    </div>
  );
};
